import { render, staticRenderFns } from "./productCode_item_dialog.vue?vue&type=template&id=c44ac964"
import script from "./productCode_item_dialog.vue?vue&type=script&lang=js"
export * from "./productCode_item_dialog.vue?vue&type=script&lang=js"
import style0 from "./productCode_item_dialog.vue?vue&type=style&index=0&id=c44ac964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports